import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';

const firebaseConfig = {
  // Replace with your Firebase config
  apiKey: "AIzaSyAibEMey3n8tvJ8ujtaTaEVFTi2VIJEE1c",
  authDomain: "devopschat-7ef3b.firebaseapp.com",
  projectId: "devopschat-7ef3b",
  storageBucket: "devopschat-7ef3b.firebasestorage.app",
  messagingSenderId: "238336005872",
  appId: "1:238336005872:web:8e6de1096f9c5eebca9435",
  measurementId: "G-SLHVQ4F2GV"
};

// Initialize Firebase immediately
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Set persistence to local for faster subsequent loads
setPersistence(auth, browserLocalPersistence);

export { auth };
export default app;
